import React from "react";
import { TESTIMONIALS_EDITORIAL } from "../../landingContent";
import SectionHeading from "../SectionHeading";

const EditorialTestimonialRow = ({ story, reverse }) => {
  const {
    quote,
    firstName,
    lastName,
    gradeLevel,
    subject,
    state,
    imageSrc,
    imageAlt,
  } = story;
  const role = [gradeLevel, subject].filter(Boolean).join(" ");

  return (
    <article
      className={`landing-v2-testimonials-editorial__row${
        reverse ? " landing-v2-testimonials-editorial__row--reverse" : ""
      }`}
    >
      {imageSrc ? (
        <figure className="landing-v2-testimonials-editorial__figure">
          <img src={imageSrc} alt={imageAlt || ""} loading="lazy" />
        </figure>
      ) : null}
      <div className="landing-v2-testimonials-editorial__copy">
        <blockquote className="landing-v2-testimonials-editorial__quote">
          <p>{quote}</p>
        </blockquote>
        <footer className="landing-v2-testimonials-editorial__footer">
          <cite className="landing-v2-testimonials-editorial__name">
            {firstName} {lastName}
            {state ? `, ${state}` : ""}
          </cite>
          {role ? <p className="landing-v2-testimonials-editorial__role">{role}</p> : null}
        </footer>
      </div>
    </article>
  );
};

const TestimonialsEditorialSection = ({
  embedded = false,
  showHeading = true,
  eyebrow = TESTIMONIALS_EDITORIAL.eyebrow,
  headline = TESTIMONIALS_EDITORIAL.headline,
  subheading = TESTIMONIALS_EDITORIAL.subheading,
  stories = TESTIMONIALS_EDITORIAL.stories,
  sectionClassName = "",
}) => {
  const content = (
    <>
      {showHeading ? (
        <SectionHeading
          eyebrow={eyebrow}
          headline={headline}
          subheading={subheading}
          headingLevel={2}
          headingId="testimonials-editorial-heading"
        />
      ) : null}

      <div className="landing-v2-testimonials-editorial__stack">
        {stories.map((story, index) => (
          <EditorialTestimonialRow
            key={story.id}
            story={story}
            reverse={index % 2 === 1}
          />
        ))}
      </div>
    </>
  );

  if (embedded) {
    return (
      <div className="landing-v2-testimonials-editorial landing-v2-testimonials-editorial--embedded">
        {content}
      </div>
    );
  }

  return (
    <section
      className={`landing-v2__section landing-v2__section--muted landing-v2-testimonials-editorial${
        sectionClassName ? ` ${sectionClassName}` : ""
      }`}
      aria-labelledby="testimonials-editorial-heading"
    >
      <div className="landing-v2__container">
        {content}
      </div>
    </section>
  );
};

export default TestimonialsEditorialSection;
